export enum DataSource {
  Mock = 'mock',
  Firebase = 'firebase',
  Typesense = 'typesense',
}

export interface EnvironmentConfig {
  production: boolean;
  dataSource: DataSource;
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
}
